"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("./Button");
var classNames = require("classnames");
var util_1 = require("util");
var svgs_1 = require("../utils/svgs");
var loom_formatted_string_react_1 = require("loom-formatted-string-react");
var InfoBlockStatus;
(function (InfoBlockStatus) {
    /**
     * Present neutral information which requires minimal attention. It is often used to describe temporary states
     * that may be of interest to the user but that do not negatively impact the system.
     */
    InfoBlockStatus[InfoBlockStatus["Info"] = 0] = "Info";
    /**
     * Present information about optional performance and/or health, or other information that requires minimal
     * attention.
     */
    InfoBlockStatus[InfoBlockStatus["Success"] = 1] = "Success";
    /**
     * Present information that may require attention. It is often used to describe validation errors, partial
     * failures, and other sub-optimal states that may be easily resolved.
     */
    InfoBlockStatus[InfoBlockStatus["Warning"] = 2] = "Warning";
    /**
     * Present information that requires immediate attention. It is often used to describe unanticipated failure,
     * potentially irrevocable changes, and other events that may permanently impair the system.
     */
    InfoBlockStatus[InfoBlockStatus["Critical"] = 3] = "Critical";
    /**
     * Present information regarding an account upgrade.
     * NOT INTENDED TO BE USED FROM OUI-REACT.
     * This should only be used by oui-savant.
     */
    InfoBlockStatus[InfoBlockStatus["Upgrade"] = 4] = "Upgrade";
})(InfoBlockStatus = exports.InfoBlockStatus || (exports.InfoBlockStatus = {}));
exports.iconSvgMap = (_a = {},
    _a[InfoBlockStatus.Info] = "InfoBlockInfo",
    _a[InfoBlockStatus.Success] = "InfoBlockSuccess",
    _a[InfoBlockStatus.Warning] = "InfoBlockCritical",
    _a[InfoBlockStatus.Critical] = "InfoBlockCritical",
    _a[InfoBlockStatus.Upgrade] = "InfoBlockUpgrade",
    _a);
var borderClassMap = (_b = {},
    _b[InfoBlockStatus.Info] = "oui-info-block--info",
    _b[InfoBlockStatus.Success] = "oui-info-block--success",
    _b[InfoBlockStatus.Warning] = "oui-info-block--warning",
    _b[InfoBlockStatus.Critical] = "oui-info-block--error",
    _b[InfoBlockStatus.Upgrade] = "oui-info-block--upgrade",
    _b);
/**
 * OUI info block component.
 *
 * @oui-component InfoBlock
 */
var InfoBlock = function (props) {
    var title = props.title, actions = props.actions, children = props.children, testId = props.testId;
    var status = props.status || InfoBlockStatus.Info;
    var borderClass = borderClassMap[status];
    var icon = React.createElement("span", { className: "oui-icon" }, svgs_1.default(exports.iconSvgMap[status]));
    var fullLayout = !!children || (util_1.isArray(actions) && actions.length > 1);
    var buttons = (actions || []).map(function (_a, index) {
        var title = _a.title, action = __rest(_a, ["title"]);
        return (React.createElement(Button_1.default, __assign({ key: index }, action), title));
    });
    if (fullLayout) {
        return (React.createElement("div", { className: classNames("oui-info-block", borderClass), "data-test-id": testId },
            React.createElement("div", { className: "oui-info-block__icon" }, icon),
            React.createElement("div", { className: "oui-info-block__content" },
                title && React.createElement("div", { className: "oui-info-block__title" }, title),
                children,
                React.createElement("div", { className: "oui-info-block__buttons" }, buttons))));
    }
    return (React.createElement("div", { className: classNames("oui-info-block", borderClass), "data-test-id": testId },
        React.createElement("div", { className: classNames("oui-info-block__icon", borderClass + "__icon") }, icon),
        React.createElement("div", { className: "oui-info-block__content" },
            React.createElement(loom_formatted_string_react_1.FormattedString, { inputText: title })),
        React.createElement("div", { className: "oui-info-block__button" }, buttons)));
};
exports.default = InfoBlock;
//# sourceMappingURL=InfoBlock.js.map